import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
//impoertacion componentes

import { obtenerInstituciones } from "../../Services/Rest";

function EditarGerente(props) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerGerentePorInstitucionId?InstitucionId=" +
        props.idGerente,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [postNombre, setPostNombre] = useState([]);
  const [postTelefono, setPostTelefono] = useState([]);
  const [postDepartamento, setPostDepartamento] = useState([]);
  const [postDireccion, setPostDireccion] = useState([]);
  const [postCorreo, setPostCorreo] = useState([]);
  const postData = (e) => {
    e.preventDefault(e);
    if (postNombre != "") {
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaGerente?Id=" +
          props.idGerente,
        data: {
          nombre: postNombre,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          alert("Actualizado con exito!");
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al Actualizar" + error);
        });
    }
    if (postTelefono != "") {
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaGerente?Id=" +
          props.idGerente,
        data: {
          telefono_Contacto: postTelefono,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          alert("Actualizado con exito!");
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al Actualizar" + error);
        });
    }
    if (postDepartamento != "") {
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaGerente?Id=" +
          props.idGerente,
        data: {
          ciudad: postDepartamento,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          alert("Actualizado con exito!");
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al Actualizar" + error);
        });
    }
    if (postDireccion != "") {
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaGerente?Id=" +
          props.idGerente,
        data: {
          direccion: postDireccion,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          alert("Actualizado con exito!");
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al Actualizar" + error);
        });
    }
    if (postCorreo != "") {
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaGerente?Id=" +
          props.idGerente,
        data: {
          correo_Electronico: postCorreo,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          alert("Actualizado con exito!");
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al Actualizar" + error);
        });
    }
  };
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-warning"
        onClick={handleOpenModalTest}
      >
        Editar
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">Editar </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <div>
                            Nombre
                            <textarea
                              type="text"
                              className="form-control form-control-user"
                              onChange={(e) => setPostNombre(e.target.value)}
                              disabled
                            >
                              {props.nombre}
                            </textarea>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          Telefono
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="numero contacto"
                            onChange={(e) => setPostTelefono(e.target.value)}
                          >
                            {props.telefono_Contacto}
                          </textarea>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          Ciudad
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="ciudad"
                            onChange={(e) =>
                              setPostDepartamento(e.target.value)
                            }
                          >
                            {props.ciudad}
                          </textarea>
                        </div>

                        <div className="col-sm-6 mb-3 mb-sm-0">
                          Dirección
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="direccion"
                            onChange={(e) => setPostDireccion(e.target.value)}
                          >
                            {props.direccion}
                          </textarea>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          Correo
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="correo "
                            onChange={(e) => setPostCorreo(e.target.value)}
                          >
                            {props.correo}
                          </textarea>
                        </div>
                      </div>
                      <a>
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={postData}
                        >
                          Guardar
                        </button>
                      </a>
                      <hr />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default EditarGerente;
